
import { accessAPIForResponse } from "../../services/api-services/api-implementations";


export const GetReportFlagsByStatus = async (reportMasterId) => {	
	return accessAPIForResponse("GetReportFlags", null, [reportMasterId]);
};
